import { SelfCheckIn } from '@/api/interface/self-check-in'
import Colors from '@/styles/Colors.module.scss'
import { EventHandler } from 'react'

interface Props {
  geofence?: any
  settings: SelfCheckIn['settings']
  handleCloseDialog: EventHandler<any>
  sciableName: string
}

export default function LocationProximityContent({
  geofence,
  settings,
  handleCloseDialog,
  sciableName,
}: Props) {
  const getRadiusText = () => {
    if (geofence) {
      const { radiusMi } = geofence
      if (radiusMi === 1) return `${radiusMi} mile`
      return `${radiusMi} miles`
    }
    return '1 mile'
  }

  return (
    <>
      <img src="/icons/proximity-error-icon.svg" height="80" width="80" />
      <br />
      <h2 style={{ fontSize: 20, fontWeight: 700 }}>
        Please move closer to {sciableName}.
      </h2>
      <p style={{ margin: '20px 0' }}>
        You need to be within{' '}
        <span style={{ fontWeight: 700 }}>{getRadiusText()}</span> of the
        business to join the waitlist. Try moving closer and make sure you have
        enabled location access in your browser.
      </p>
      <button
        className="btn"
        style={{
          width: '100%',
          height: 60,
          fontSize: '1.25rem',
          fontWeight: 'bold',
          marginTop: '0.875rem',
          marginBottom: '1rem',
          borderRadius: '99px',
          backgroundColor:
            settings?.btnBackgroundColor || Colors['theme-green'],
          color: settings?.btnTextColor || Colors['theme-white'],
        }}
        onClick={(e) => {
          handleCloseDialog('closeButton')
        }}
      >
        Try Again
      </button>
    </>
  )
}
